// export const searchChoicesReducer = () => {
//   return [
//     {
//       label: 'FD Env',
//       value: 'fqen',
//     },
//     {
//       label: 'Version',
//       value: 'versionBuildNumber',
//     },
//     {
//       label: 'Biit',
//       value: 'biitAddress',
//     }
//   ]
// }

export default (state= "fqen", action: { type: string, payload: string }) => {
  switch (action.type) {
    case "SEARCH_BY":
      return action.payload;
    default:
      return state;
  }
}
